import l from "./ContentLoading";

export default l;

// import React from "react";
// import { CanotisBOSIco } from "../localResouces";

// // Material components
// import { CircularProgress } from "@material-ui/core";

// function Loading(props) {

//   const wrapperStyle = {
//     display: "flex",
//     height: "100%",
//     margin: "10px"
//   };

//   const contentStyle = {
//     margin: "auto",
//     height: "60px"
//   }

//   const logoImageStyle = {
//     width: 30,
//     height: 30,
//     position: "absolute",
//     marginLeft: 10,
//     marginTop: 10
//   }

//   return (
//     <div style={wrapperStyle}>
//       <div style={contentStyle}>
//         <img alt="Canotis BOS Icon" style={logoImageStyle} src={CanotisBOSIco} />
//         <CircularProgress size={50} />
//       </div>
//     </div>
//   );
// }

// export default (Loading);
